

/// <reference path="BankEntry.ts" />

// Generated class BankMovement_ManagedObject

class BankMovement_ManagedObject extends BankEntry
{

    // Property: bankBranch
    set bankBranch(value:string) {
        this.setValueForKey(value, 'bankBranch');
    }
    get bankBranch():string {
        return this.valueForKey('bankBranch');
    }
    set bankBranchPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'bankBranch');
    }
    get bankBranchPrimitiveValue():string {
        return this.primitiveValueForKey('bankBranch');
    }

    // Property: beneficiaryAccountNumber
    set beneficiaryAccountNumber(value:string) {
        this.setValueForKey(value, 'beneficiaryAccountNumber');
    }
    get beneficiaryAccountNumber():string {
        return this.valueForKey('beneficiaryAccountNumber');
    }
    set beneficiaryAccountNumberPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'beneficiaryAccountNumber');
    }
    get beneficiaryAccountNumberPrimitiveValue():string {
        return this.primitiveValueForKey('beneficiaryAccountNumber');
    }

    // Property: beneficiaryIBAN
    set beneficiaryIBAN(value:string) {
        this.setValueForKey(value, 'beneficiaryIBAN');
    }
    get beneficiaryIBAN():string {
        return this.valueForKey('beneficiaryIBAN');
    }
    set beneficiaryIBANPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'beneficiaryIBAN');
    }
    get beneficiaryIBANPrimitiveValue():string {
        return this.primitiveValueForKey('beneficiaryIBAN');
    }

    // Property: beneficiaryName
    set beneficiaryName(value:string) {
        this.setValueForKey(value, 'beneficiaryName');
    }
    get beneficiaryName():string {
        return this.valueForKey('beneficiaryName');
    }
    set beneficiaryNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'beneficiaryName');
    }
    get beneficiaryNamePrimitiveValue():string {
        return this.primitiveValueForKey('beneficiaryName');
    }

    // Property: dataCode
    set dataCode(value:number) {
        this.setValueForKey(value, 'dataCode');
    }
    get dataCode():number {
        return this.valueForKey('dataCode');
    }
    set dataCodePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'dataCode');
    }
    get dataCodePrimitiveValue():number {
        return this.primitiveValueForKey('dataCode');
    }

    // Property: documentNumber
    set documentNumber(value:string) {
        this.setValueForKey(value, 'documentNumber');
    }
    get documentNumber():string {
        return this.valueForKey('documentNumber');
    }
    set documentNumberPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'documentNumber');
    }
    get documentNumberPrimitiveValue():string {
        return this.primitiveValueForKey('documentNumber');
    }

    // Property: dueDate
    set dueDate(value:Date) {
        this.setValueForKey(value, 'dueDate');
    }
    get dueDate():Date {
        return this.valueForKey('dueDate');
    }
    set dueDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'dueDate');
    }
    get dueDatePrimitiveValue():Date {
        return this.primitiveValueForKey('dueDate');
    }

    // Property: reference
    set reference(value:string) {
        this.setValueForKey(value, 'reference');
    }
    get reference():string {
        return this.valueForKey('reference');
    }
    set referencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'reference');
    }
    get referencePrimitiveValue():string {
        return this.primitiveValueForKey('reference');
    }

    // Property: reference1
    set reference1(value:string) {
        this.setValueForKey(value, 'reference1');
    }
    get reference1():string {
        return this.valueForKey('reference1');
    }
    set reference1PrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'reference1');
    }
    get reference1PrimitiveValue():string {
        return this.primitiveValueForKey('reference1');
    }

    // Property: reference2
    set reference2(value:string) {
        this.setValueForKey(value, 'reference2');
    }
    get reference2():string {
        return this.valueForKey('reference2');
    }
    set reference2PrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'reference2');
    }
    get reference2PrimitiveValue():string {
        return this.primitiveValueForKey('reference2');
    }

    // Relationship: documentLink
    protected _documentLink:MIOManagedObjectSet = null;
    get documentLink():MIOManagedObjectSet {
        return this.valueForKey('documentLink');
    }
    addDocumentLinkObject(value:BankMovementDocumentLink) {
        this._addObjectForKey(value, 'documentLink');
    }
    removeDocumentLinkObject(value:BankMovementDocumentLink) {
        this._removeObjectForKey(value, 'documentLink');
    }
}
